import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Header from './../components/Header'
import Footer from "./../components/Footer";
import Loading from "./../components/Loading";

const Home = () => {
    const [ticketTypeIdRegister, setTicketTypeIdRegister] = useState(0);
    const [ticketTypeIdDeregister, setTicketTypeIdDeregister] = useState(0);
    const [posId, setPosId] = useState(0);
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [resources, setResources] = useState({});
    const [orderId, setOrderId] = useState("");
    const [availabilityRegister, setAvailabilityRegister] = useState(null);
    const [availabilityDeregister, setAvailabilityDeregister] = useState(null);
    const [agbAccepted, setAgbAccepted] = useState(false);
    const [token, setToken] = useState(sessionStorage.getItem("token"));
    const [errors, setErrors] = useState("");

    const [buyerInfo, setBuyerInfo] = useState({
        salutation: "",
        firstName: "",
        name: "",
        company: "",
        telephone: "",
        email: "",
        street: "",
        city: "",
        postCode: "",
        code1: "", //remark
        countryId: 176, // Default to Switzerland
    });

    const navigate = useNavigate();
    const baseUrl = process.env.REACT_APP_BASEURL_API;
    const language = "de"; // Default language

    useEffect(() => {
        loadToken();
    }, []);

    const loadToken = () => {
        axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            setToken(res.data);
            sessionStorage.setItem("token", res.data);
            requestFormSettings();
        });
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            setTicketTypeIdRegister(res.data.registerTicketTypeId);
            setTicketTypeIdDeregister(res.data.deregisterTicketTypeId);
            setPosId(res.data.posId);
            startOrder(res.data.posId, res.data.registerTicketTypeId, res.data.deregisterTicketTypeId);
        });
    };

    const startOrder = (posId, ticketTypeId1, ticketTypeId2) => {
        let order = {
            affiliateShopId: null,
            currency: "CHF",
            tenantId: 1,
            pointOfSaleId: posId,
            abbreviation: "",
            paymentType: 1,
            deliveryType: 1,
        };

        axios
            .post(`${baseUrl}/ShopBasket/Order`, order)
            .then((res) => {
                sessionStorage.setItem("orderId", res.data.id);
                setOrderId(res.data.id);
                // Check availability after order is created
                checkAvailability(res.data.id, ticketTypeId1, ticketTypeId2);
            })
            .catch((error) => console.error(error.response.data));
    };

    const checkAvailability = async (orderId, ticketTypeId1, ticketTypeId2) => {
        try {
            // Check availability for Register
            const availability1 = await requestTicketTypeAvailability(ticketTypeId1, orderId);
            setAvailabilityRegister(availability1);

            // Check availability for Deregister
            const availability2 = await requestTicketTypeAvailability(ticketTypeId2, orderId);
            setAvailabilityDeregister(availability2);
        } catch (error) {
            console.error("Error checking availability:", error);
        }
    };

    const requestTicketTypeAvailability = async (ticketTypeId, orderId) => {
        if (!ticketTypeId || !orderId) return null;

        try {
            const url = `${baseUrl}/TicketType/${ticketTypeId}/Availability?orderId=${orderId}`;
            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            console.error(`Error fetching availability for ticket type ${ticketTypeId}:`, error);
            return null;
        }
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/de`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    useEffect(() => {
        requestResources();
    }, []);

    const onInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setBuyerInfo((prevBuyerInfo) => ({
            ...prevBuyerInfo,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const validateEntries = () => {
        if (!(buyerInfo.salutation && buyerInfo.salutation.trim() !== "") ||
            !(buyerInfo.firstName && /^.{1,70}$/.test(buyerInfo.firstName)) ||
            !(buyerInfo.name && /^.{1,70}$/.test(buyerInfo.name)) ||
            !(buyerInfo.company && /^.{1,70}$/.test(buyerInfo.company)) ||
            !agbAccepted) {
            setErrors(resources?.FillMandatoryFields);
            return false;
        }
        else if (!(buyerInfo.email && /^\S+@\S+\.\S+$/.test(buyerInfo.email))) {
            setErrors(resources?.EmailNotCorrect);
            return false;
        }
        setErrors("");
        return true;
    }

    const addTicketToBasket = async (selectedTicketTypeId) => {
        let addTicketTypes = [];

        addTicketTypes.push({
            ticketTypeId: parseInt(selectedTicketTypeId),
            quantity: 1,
            salutation: buyerInfo.salutation,
            firstname: buyerInfo.firstName,
            lastname: buyerInfo.name,
            company: buyerInfo.company,
            email: buyerInfo.email,
            street: buyerInfo.street,
            postCode: buyerInfo.postCode,
            city: buyerInfo.city,
            country: "Schweiz",
            option11: buyerInfo.code1, //remark
        });

        await axios
            .post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                ticketsToAdd: addTicketTypes,
            })
            .then(() => {
                addAddressToBasket();
            })
            .catch((error) => {
                console.error(error.response.data);
                setErrors(resources?.ErrorOccurred || "An error occurred");
                setIsSubmitting(false);
            });
    };

    const addAddressToBasket = async () => {
        let addressBody = { ...buyerInfo };

        await axios
            .put(`${baseUrl}/Order/${orderId}/Address`, addressBody)
            .then(() => {
                // gtm - addAddress
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'addAddress'
                });
                finishFreeOrder();
            })
            .catch((error) => {
                console.error(error.response.data);
                setErrors(resources?.ErrorOccurred || "An error occurred");
                setIsSubmitting(false);
            });
    };

    const finishFreeOrder = async () => {
        await axios
            .put(`${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/5`)
            .then(() => {
                confirmShopbasketByOrderId(orderId);
                navigate(`/${language}/opening-day/confirmation/${orderId}`);
            })
            .catch((error) => {
                console.error(error.response.data);
                setErrors(resources?.ErrorOccurred || "An error occurred");
                setIsSubmitting(false);
            });
    };

    const confirmShopbasketByOrderId = async (orderId) => {
        try {
            const res = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Confirm`);
        } catch (error) {
            console.error(error)
        }
    };

    const handleRegister = async () => {
        // Prevent double submission
        if (isSubmitting) {
            return;
        }

        if (validateEntries()) {
            setIsSubmitting(true);

            try {
                // Store ticket type ID for confirmation page
                sessionStorage.setItem("SelectedTicketTypeId", ticketTypeIdRegister);

                await addTicketToBasket(ticketTypeIdRegister);
            } catch (error) {
                console.error("Error during registration:", error);
                setErrors(resources?.ErrorOccurred || "An error occurred");
                setIsSubmitting(false);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const handleDeregister = async () => {
        // Prevent double submission
        if (isSubmitting) {
            return;
        }

        if (validateEntries()) {
            setIsSubmitting(true);

            try {
                // Store ticket type ID for confirmation page
                sessionStorage.setItem("SelectedTicketTypeId", ticketTypeIdDeregister);

                await addTicketToBasket(ticketTypeIdDeregister);
            } catch (error) {
                console.error("Error during deregistration:", error);
                setErrors(resources?.ErrorOccurred || "An error occurred");
                setIsSubmitting(false);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    // Helper function to check if a ticket type is sold out
    const isSoldOut = (availability) => {
        return availability && availability.status !== 0;
    };

    return (
        <div>
            <Header resources={resources} title={resources?.HomeTitle} />
            {loading ? (
                <Loading
                    alignment="center"
                    color="#d3d3d3"
                    bgColor="#fff"
                    top="50%"
                />
            ) : (
                <>
                    <div className="container page-container">

                        <div className="mt-4 page-container-smaller">

                            <div className="mt-5 mb-2">
                                <p dangerouslySetInnerHTML={{ __html: resources?.HomeTitleDescription }}></p>
                            </div>

                            {errors !== "" && (
                                <div className="alert alert-danger" role="alert">
                                    {errors}
                                </div>
                            )}

                            {/* Buyer Information Form Section */}
                            <div className="mt-5 mb-5 buyer-information-box">

                                <span className="mandatory">*</span><span>{resources?.BuyerMandatoryFields}</span>

                                <h5 className="subtitle mt-4 mb-5">{resources?.BuyerInformation}</h5>

                                {/* Salutation */}
                                <div className="mb-4">
                                    <label className="form-label text-buyer-input" htmlFor="salutation">
                                        {resources?.BuyerSalutation} <span className="mandatory">*</span>
                                    </label>
                                    <select
                                        name="salutation"
                                        id="salutation"
                                        className="form-select"
                                        value={buyerInfo.salutation}
                                        onChange={onInputChange}
                                    >
                                        <option value="">{resources?.BuyerSalutationChoose}</option>
                                        <option value={resources?.Mr}>{resources?.Mr}</option>
                                        <option value={resources?.Ms}>{resources?.Ms}</option>
                                        <option value={resources?.Diverse}>{resources?.Diverse}</option>
                                    </select>
                                </div>

                                {/* First Name */}
                                <div className="mb-4">
                                    <label className="form-label text-buyer-input" htmlFor="firstName">
                                        {resources?.BuyerFirstname} <span className="mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="firstName"
                                        className="form-control"
                                        value={buyerInfo.firstName}
                                        id="firstName"
                                        onChange={onInputChange}
                                    />
                                </div>

                                {/* Last Name */}
                                <div className="mb-4">
                                    <label className="form-label text-buyer-input" htmlFor="name">
                                        {resources?.BuyerLastname} <span className="mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control"
                                        value={buyerInfo.name}
                                        id="name"
                                        onChange={onInputChange}
                                    />
                                </div>

                                {/* Company */}
                                <div className="mb-4">
                                    <label className="form-label text-buyer-input" htmlFor="company">
                                        {resources?.BuyerCompany} <span className="mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="company"
                                        className="form-control"
                                        value={buyerInfo.company}
                                        id="company"
                                        onChange={onInputChange}
                                    />
                                </div>

                                {/* Street */}
                                <div className="mb-4">
                                    <label className="form-label text-buyer-input" htmlFor="street">
                                        {resources?.BuyerStreet}
                                    </label>
                                    <input
                                        type="text"
                                        name="street"
                                        className="form-control"
                                        value={buyerInfo.street}
                                        id="street"
                                        onChange={onInputChange}
                                    />
                                </div>

                                {/* Postcode */}
                                <div className="mb-4">
                                    <label className="form-label text-buyer-input" htmlFor="postCode">
                                        {resources?.BuyerPostcode}
                                    </label>
                                    <input
                                        type="text"
                                        name="postCode"
                                        className="form-control"
                                        value={buyerInfo.postCode}
                                        id="postCode"
                                        onChange={onInputChange}
                                    />
                                </div>

                                {/* City */}
                                <div className="mb-4">
                                    <label className="form-label text-buyer-input" htmlFor="city">
                                        {resources?.BuyerCity}
                                    </label>
                                    <input
                                        type="text"
                                        name="city"
                                        className="form-control"
                                        value={buyerInfo.city}
                                        id="city"
                                        onChange={onInputChange}
                                    />
                                </div>

                                {/* Phone */}
                                <div className="mb-4">
                                    <label className="form-label text-buyer-input" htmlFor="telephone">
                                        {resources?.BuyerPhone} <span className="mandatory">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="telephone"
                                        className="form-control"
                                        value={buyerInfo.telephone}
                                        id="telephone"
                                        onChange={onInputChange}
                                    />
                                </div>

                                {/* Email */}
                                <div className="mb-4">
                                    <label className="form-label text-buyer-input" htmlFor="email">
                                        {resources?.BuyerEmail} <span className="mandatory">*</span>
                                    </label>
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        value={buyerInfo.email}
                                        id="email"
                                        onChange={onInputChange}
                                    />
                                </div>

                                {/* Remark */}
                                <div className="mb-4">
                                    <label className="form-label text-buyer-input" htmlFor="code1">
                                        {resources?.BuyerRemark}
                                    </label>
                                    <input
                                        type="text"
                                        name="code1"
                                        className="form-control"
                                        value={buyerInfo.code1}
                                        id="code1"
                                        onChange={onInputChange}
                                    />
                                </div>

                                {/* AGB */}
                                <div className="mt-5">
                                    <p className="form-label agb-label">AGB & DATENSCHUTZBESTIMMUNGEN *</p>
                                    <div className="agb-checkbox-row">
                                        <input
                                            type="checkbox"
                                            id="agbCheckbox"
                                            checked={agbAccepted}
                                            onChange={(e) => setAgbAccepted(e.target.checked)}
                                            className="agb-checkbox"
                                        />
                                        <label htmlFor="agbCheckbox" className="agb-text">
                                            Ich bin damit einverstanden, dass meine personenbezogenen Daten im Rahmen der Organisation und Durchführung der offiziellen Eröffnung Neubau Kinderspital/Frauenklinik gespeichert und verarbeitet werden. Ich nehme zur Kenntnis, dass während der Veranstaltung Fotos und Videos gemacht werden, auf denen ich möglicherweise erkennbar bin, und erkläre mich damit einverstanden, dass diese zu Marketingzwecken (z.B. Medienmitteilung, Social Media-Kanäle) verwendet werden.
                                        </label>
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-12">
                                        <button
                                            className="btn btn-custom btn-register"
                                            onClick={handleRegister}
                                            disabled={isSubmitting || isSoldOut(availabilityRegister)}
                                        >
                                            {resources?._Register}
                                            {isSoldOut(availabilityRegister) && (
                                                <span className="ms-2">(Ausverkauft)</span>
                                            )}
                                        </button>
                                    </div>
                                </div>

                                <div className="row mt-3 mb-2">
                                    <div className="col-12">
                                        <button
                                            className="btn btn-custom btn-deregister"
                                            onClick={handleDeregister}
                                            disabled={isSubmitting || isSoldOut(availabilityDeregister)}
                                        >
                                            {resources?._Deregister}
                                            {isSoldOut(availabilityDeregister) && (
                                                <span className="ms-2">(Ausverkauft)</span>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </>
            )}
        </div>
    )
}

export default Home